const $home = $('.js-home');
const $window = $(window);

const home = {
  initialize() {
    if (!$home.length) {
      return;
    }

    this.createEventListeners();
    this.getWindowDimensions();
    this.checkServiceHeadingHeights();
  },

  createEventListeners() {
    $window.on('resize', () => {
      this.getWindowDimensions();
      this.checkServiceHeadingHeights();
    });

    $window.on('load', () => {
      this.checkServiceHeadingHeights();
    });
  },

  getWindowDimensions() {
    this.windowWidth = $window.width();
  },

  checkServiceHeadingHeights() {
    const $headings = $home.find('.js-service-heading');

    $headings.css('height', 'auto');

    if (this.windowWidth >= 768) {
      // Equal
      const tallestHeight = $headings.toArray().reduce((acc, heading) => {
        const headingHeight = $(heading).height();
        return headingHeight > acc ? headingHeight : acc;
      }, 0);

      // Add break if it's exactly two words long
      $headings.toArray().forEach((heading) => {
        const text = heading.textContent.trim();
        const words = text.split(' ');
        const headingHeight = $(heading).height();

        if (headingHeight < tallestHeight && words.length === 2) {
          heading.innerHTML = words.join('<br>');
        }
      });

      $headings.css('height', tallestHeight);
      return;
    }

    $headings.find('br').replaceWith('&nbsp;');
  },
};

export default home;
